import { WCS } from '../../week-utils';
import styled from 'styled-components';

export const BackgroundGridSC = styled.div<{ cellHeight: number }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-top: ${WCS.gridPadding}px;
  overflow: hidden;
  background: white;

  .row {
    width: 100%;
    height: ${({ cellHeight }) => cellHeight}px;
    position: relative;
    display: flex;
    box-sizing: border-box;

    .time {
      width: 100%;
      height: 100%;
      max-width: 100px;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: rgba(24, 30, 53, 0.6);
      background: white;
      mix-blend-mode: normal;

      .time-display {
        width: ${WCS.timeLineWidth - 40}px;
        min-width: ${WCS.timeLineWidth - 40}px;
        margin-top: -10px;
        border-radius: 12px;
        background: white;
        z-index: 1;
      }
    }

    .content {
      width: 100%;
      height: 100%;
      background: white;
    }

    &:first-child {
      .time-display {
        visibility: hidden;
      }
    }

    &:nth-child(even) {
      .content {
        background: rgba(251, 251, 251, 0.8);
      }

      .time {
        border-top: 2px solid rgba(251, 251, 251, 0.8);
        border-bottom: 2px solid rgba(251, 251, 251, 0.8);

        .time-display {
          margin-top: -12px;
        }
      }
    }
  }

  .day-progress {
    position: absolute;
    left: 0;
    width: 100%;
    height: 12px;
    z-index: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    pointer-events: none;

    .time {
      width: ${WCS.timeLineWidth - 40}px;
      min-width: ${WCS.timeLineWidth - 40}px;
      margin-left: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      border-radius: 12px;
      background: white;
      color: rgba(255, 68, 150, 1);
      box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.1);
    }

    .dot {
      position: absolute;
      background: rgba(255, 68, 150, 1);
      width: 7px;
      height: 7px;
      border-radius: 50%;
    }

    .line {
      width: 100%;
      border-bottom: 1px solid rgba(255, 68, 150, 0.2);
    }
  }
`;
